export default __webpack_public_path__ + "eedf95e6832f0cdc01c0cd6914b802c3.svg";